import styled from "styled-components";

export const Divider = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 37px;
  margin-bottom: 32px;

  & :first-child {
    height: 1px;
    flex-grow: 1;
    background: linear-gradient(90deg, rgba(39, 39, 42, 0) 0%, #3F3F46 100%);
    margin-right: 25px;
  }
  
  & :last-child {
    height: 1px;
    flex-grow: 1;
    background: linear-gradient(90deg, #3F3F46 0%, rgba(39, 39, 42, 0) 100%);
    margin-left: 25px;
  }
`